module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Success":"Les listes corporatives ont été changées avec succès."},"fr":{"Success":"Les listes corporatives ont été changées avec succès."}}')
  delete Component.options._Ctor
}
